export default "<div class=\"container p-0\">\r\n<div class=\"circle-ripple\"></div>\r\n</div>"